<template lang="pug">
    v-data-table.elevation-1(v-if='!read' :loading='loading' v-model='selected' :headers='headers' :items='despachar' :single-select='singleSelect' item-key='numFactura' show-select )
        template(v-slot:top)
          v-toolbar.head-toolbar-pdespacho(flat dense color='primary' dark)
            v-flex.flex(class="d-flex flex-wrap justify-center")
              v-toolbar-title Facturas
              v-divider.mx-4(inset vertical)
              v-spacer
              v-text-field.text-xs-center.search(v-model='search' append-icon="search" label='Buscar' single-line hide-details color='success')
            v-spacer
            v-btn.mx-2(v-show='selected.length > 0' color='success' dark @click='cargarFacturas') Subir carga
        template(v-slot:no-data)
          h2.pa-2 No hay Facturas para despachar
</template>

<script>
import Api from '@/services/methods'
export default {
  props: ['read', 'despachar', 'loading'],
  data: () => ({
    search: '',
    singleSelect: false,
    selected: [],
    desserts: [],
    headers: [
      { text: 'Numero de factura', value:'numFactura'},
      {
        text: 'Fecha',
        align: 'left',
        sortable: false,
        value: 'fechaFact'
      },
      { text: 'Cliente', value: 'cliente', sortable: false },
      { text: 'Direccion', value: 'direccion', sortable: false },
      { text: 'Total', value: 'total', sortable: false },
      { text: 'Zona', value: 'zona', sortable: false },
      { text: 'Vendedor(usuario)', value: 'vendedor', sortable: false }
    ]
    // formFactura: {
    //   _id: "",
    //   fechaFact: "",
    //   documento: "",
    //   cliente: "",
    //   direccion: "",
    //   total: "",
    //   zona: "",
    //   vendedor: ""
    // },
  }),

  watch: {
    selected (val) {
    }
  },

  methods: {

    formato (fecha) {
      return this.$moment(fecha).format('YYYY-MM-DD, HH:mm:ss')
    },

    cargarFacturas () {
      this.selected.map(factura => {
        this.despachar.splice(this.despachar.indexOf(factura), 1)
      })
      this.$emit('cargar', this.selected)
      this.selected = []
    }
  }
}
</script>
<style lang="scss">
  @media screen and (max-width: 425px) {
    .head-toolbar-pdespacho, .head-toolbar-fdespacho .v-toolbar__content  {
      height: 80px !important;
    }
    .search {
      margin-bottom: 10px;
    }
    .main-head {
      font-size: 1.3rem;
    }
  }
</style>